import { UserRole } from '@/types';

export const hierarchyColumnsByRole: Record<string, Array<'SP' | 'AD' | 'SM' | 'SSM' | 'MA'>> = {
  OWNER: ['SP', 'AD', 'SM', 'SSM', 'MA'],
  ADMIN: ['SM', 'SSM', 'MA'],
  'SUPER MASTER': ['SSM', 'MA'],
  'SUB SUPER MASTER': ['MA'],
  MASTER: [],
};

export const roleNameToNextNameMap: Partial<Record<string, string[]>> = {
  OWNER: ['ADMIN', 'SUPER MASTER', 'SUB SUPER MASTER', 'MASTER', 'USER'],
  ADMIN: ['SUPER MASTER', 'SUB SUPER MASTER', 'MASTER', 'USER'],
  'SUPER MASTER': ['SUB SUPER MASTER', 'MASTER', 'USER'],
  'SUB SUPER MASTER': ['MASTER', 'USER'],
  MASTER: ['USER'],
  USER: [],
};
